import type { FaireProductEntity } from "../../entity_types/product";

export const p_2sdcb4vgn4: FaireProductEntity = {
  token: "p_2sdcb4vgn4",
  type: "product",
  name: "Arkansas Razorbacks Red Sleeveless Cheerleader Dress",
  brandToken: "b_8jehdemzqt",
  brandName: "Vive La Fete",
  imageUrl:
    "https://cdn.faire.com/fastly/de36453f31911485495ae9af3573a6e1f4fa27611d2f51e3d402b473782fa00b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/83f2f20e38ef8ed556fd13ef37727dc3049b1ba43483a3ba5e403449f86f450a.jpeg",
    "https://cdn.faire.com/fastly/a8a5b91222441f4c343ed136d355992fcf10a7893adb7cffaf79bba76fda6940.jpeg",
    "https://cdn.faire.com/fastly/a836de9c0bf56543c69914d473c8e248ebdb14e3651499f15c57fd9f67943692.jpeg",
  ],
  priceDollars: 21.95,
  description:
    "Let your daughter look cool in her new team spirit Cheer Cheerleader Dress. Let her play, enjoy the games, cheer loudly and proudly with her favorite team gear by Vive La Fete. Celebrate and cheer on game day with our classic design favorite team cheerleader dress with pleated skirt. Officially Licensed product sold by Vive La Fete. This awesome graphics, fun and game day cheerleader jumper features officially licensed your team colors and graphics will become an essential part of her wardrobe; perfect to cheer for her favorite team. This timeless design cheerleader dress made with top-quality long-lasting four-way stretch polyester spandex blend, sublimated moisture wicking soft knit fabric that holds its colors forever. Performance fabric that's comfy, strong, and breathable, UPF50.",
  tags: [],
  msrpDollars: 51.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:24:24.389Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
